import { render, staticRenderFns } from "./MovimientoStock.vue?vue&type=template&id=e7b4656a&"
import script from "./MovimientoStock.vue?vue&type=script&lang=js&"
export * from "./MovimientoStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports